/**
 * Auth context — wraps AuthResult so any component can read is_admin, lang, etc.
 */

import { createContext, useContext, useState, type ReactNode } from "react";
import type { AuthResult } from "@/tg/auth";

interface AuthCtx {
  auth: AuthResult | null;
  setAuth: (a: AuthResult) => void;
}

const AuthContext = createContext<AuthCtx | null>(null);

export function AuthProvider({ children }: { children: ReactNode }) {
  const [auth, setAuth] = useState<AuthResult | null>(null);
  return <AuthContext.Provider value={{ auth, setAuth }}>{children}</AuthContext.Provider>;
}

export function useAuth(): AuthCtx {
  const ctx = useContext(AuthContext);
  if (!ctx) throw new Error("useAuth must be used inside AuthProvider");
  return ctx;
}
